module.exports = __webpack_public_path__ + "img/trans-banner.98951055.png";